import { GET } from "api/config";

export const mainBanner = async (mobile) => await GET(`/main/${mobile}/banner`);

export const footerBanner = async (mobile) =>
  await GET(`/main/${mobile}/middle/banner`);
